import type { DeAddressVerificationResult } from '@ps/web-core-enums';
import { Site } from '@ps/web-core-enums';

import type { StatusCode } from '@swf/core/enums/statusCode';

import type { ErrorCollection } from './Response';

/* eslint-disable no-bitwise */
// TODO: EmailFlags should be merged with UserFlags above
export enum EmailFlag {
  Verified = 1 << 0,
  Bounced = 1 << 6,
  NotAuthorized = 1 << (51 - 32),
  AlwaysValidated = 1 << (50 - 32)
}

export interface EmailValidationFlags {
  verified: boolean;
  bounced: boolean;
  notAuthorized: boolean;
  alwaysValidated: boolean;
}

export interface Response {
  success: boolean;
  message?: string;
  errors?: ErrorCollection;
  statusCode?: StatusCode;
  messages?: { msg: { error: string } };
  deAddressVerificationResult?: DeAddressVerificationResult;
}

export interface AccountLocales {
  emLocale: number;
  emLocale2: number;
  emLocale3: number;
}
export interface AccountInfo {
  name?: string;
  addr1?: string;
  city?: string;
  zipCode?: string;
  state?: string;
  country?: string;
  countryCode?: string;
  phone?: string;
}

export const depositLimitExtendedSites = [
  Site.COM,
  Site.DE,
  Site.DESH,
  Site.DK,
  Site.ES,
  Site.EU,
  Site.GR,
  Site.NL,
  Site.PT,
  Site.RO,
  Site.SE,
  Site.UK,
  Site.USCO,
  Site.USMI,
  Site.USNJ,
  Site.USPA,
  Site.CAON
];

export enum UpdateAccountDetailsAction {
  Cancel,
  Confirm,
  Update
}
